import styled from 'styled-components'

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  padding-bottom: ${props => props.theme.spacing.sp32};
`

export const PermissionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  padding: ${props => props.theme.spacing.sp32} 0;
`

export const UsersCountContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`
